import Cookie from "js-cookie";
//import store from '@/store';

export default {
  auth(to, from, next) {
    const token = Cookie.get("_token");
    
    if (!token && to.path !== "/auth") {
      return next("/auth");
    }

    next();
  },

  login(to, from, next) {
    const token = Cookie.get("_token");

    if (token) {
      next("/home");
    } else {
      next();
    }
  },
};
